import { useCallback, useState } from "react";
import type { CollectionFetcherResult } from "./types";

export function serverCollectionQueryKey(input: { q: string; pageSize: number; sort: unknown; sortStack: unknown; filters: unknown }): string {
  return JSON.stringify(input);
}

interface ServerCollectionState<RowT> {
  rows: RowT[];
  total: number;
  hasTotal: boolean;
  accept: (result: CollectionFetcherResult<RowT>) => void;
  clear: () => void;
}

export function useServerCollectionState<RowT>(isServer: boolean, queryKey: string): ServerCollectionState<RowT> {
  const [rows, setRows] = useState<RowT[]>([]);
  const [total, setTotal] = useState(0);
  const [totalQueryKey, setTotalQueryKey] = useState<string | null>(null);

  const accept = useCallback((result: CollectionFetcherResult<RowT>) => {
    setRows(result.rows);
    setTotal(result.total);
    setTotalQueryKey(queryKey);
  }, [queryKey]);
  const clear = useCallback(() => {
    setRows([]);
    setTotal(0);
  }, []);

  return { rows, total, hasTotal: !isServer || totalQueryKey === queryKey, accept, clear };
}
